/* File: storage.jsx
 * Path: ananunadm/src/helpers/storage.jsx
*/
import React from "react";

export const useStateWithLocalStorage = (localStorageKey) => {
	const [value, setValue] = React.useState(localStorage.getItem(localStorageKey) || "");

	React.useEffect(() => {
		localStorage.setItem(localStorageKey, value);
	}, [value, localStorageKey]);

	return [value, setValue];
};
